var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#04223a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.809-7.162H6.921L5.863-4.713a5.45,5.45,0,0,0-.52,2.022A1.68,1.68,0,0,0,6.2-1.132a7.179,7.179,0,0,0,2.468.445V0H.3V-.687A3.741,3.741,0,0,0,2.523-1.809,14.921,14.921,0,0,0,4.676-5.6l9-20.076h.353L23.1-5.047a12.566,12.566,0,0,0,2.134,3.692,2.914,2.914,0,0,0,1.781.668V0H14.844V-.687h.5a3.811,3.811,0,0,0,2.06-.408.991.991,0,0,0,.408-.854,2.274,2.274,0,0,0-.111-.687q-.037-.167-.557-1.392Zm-.631-1.373L11.43-17.2,7.57-8.535Z",
    transform: "translate(14 38)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo_circle.79f40db49cb04aa635eea90ea081a328.svg";
export { ForwardRef as ReactComponent };